import GET_EXHIBITOR_DETAILS from './GET_EXHIBITOR_DETAILS';
import GET_EXHIBITORS from './GET_EXHIBITORS';
import GET_KEYNOTES from './GET_KEYNOTES';
import GET_MEDIA_PARTNER_DETAILS from './GET_MEDIA_PARTNER_DETAILS';
import GET_MEDIA_PARTNERS from './GET_MEDIA_PARTNERS';
import GET_PERSONALITIES from './GET_PERSONALITIES';
import GET_ROUND_TABLE_DETAILS from './GET_ROUND_TABLE_DETAILS';
import GET_ROUND_TABLES from './GET_ROUND_TABLES';
import GET_SPONSORS_DETAILS from './GET_SPONSORS_DETAILS';
import GET_SPONSORS from './GET_SPONSORS';
import GET_TESTIMONIALS from './GET_TESTIMONIALS';

export {
    GET_EXHIBITOR_DETAILS,
    GET_EXHIBITORS,
    GET_KEYNOTES,
    GET_MEDIA_PARTNER_DETAILS,
    GET_MEDIA_PARTNERS,
    GET_PERSONALITIES,
    GET_ROUND_TABLE_DETAILS,
    GET_ROUND_TABLES,
    GET_SPONSORS_DETAILS,
    GET_SPONSORS,
    GET_TESTIMONIALS,
};



/** WEBPACK FOOTER **
 ** ./src/graphql/index.js
 **/